import { render, staticRenderFns } from "./ProfileGallery.vue?vue&type=template&id=31f9a794&scoped=true&"
import script from "./ProfileGallery.vue?vue&type=script&lang=js&"
export * from "./ProfileGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGallery.vue?vue&type=style&index=0&id=31f9a794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9a794",
  null
  
)

export default component.exports